import React, { useEffect, useState } from 'react';
import { authenticationService } from '../services/authenticationService';
import { getQueryStringParameter } from '../app/getQueryStringParameter';

export const LoginWithToken = () => {
    const [message, setMessage] = useState("Validating token...");

    useEffect(() => {
        const baseTitle = "OTT";
        document.title = "Login";

        if (baseTitle !== "") {
            document.title += ` | ${baseTitle}`;
        }

        const token = getQueryStringParameter("token");

        if (!token) {
            setMessage("No token");
            return;
        }

        const loginPromise = authenticationService.loginWithToken(token);

        loginPromise
            .then(() => {
                window.location = "/";
            })
            .catch(error => {
                setMessage(error.message);
            });
    }, []);

    return (
        <div>
            {message}
        </div>
    );
}